import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { el } from "../lib/dom";
import { picture } from "../lib/image";
import { sectionCover } from "../lib/sectionCover";
import { photos } from "../content/photos.generated";
import { buzz } from "../lib/haptics";

export function renderGallery(root: HTMLElement) {
  const page = el("section", { class: "page", id: "galery" });

  page.appendChild(
    sectionCover({
      title: "Foto's",
      photo: photos.gallery[19] ?? photos.gallery[0] ?? null,  // IMG_4791
    }),
  );

  const content = el("div", { class: "page__content" });

  // Portraits only — landscape shots don't fill the column nicely.
  const portraitPhotos = photos.gallery.filter((p) => p.aspect < 1);

  if (portraitPhotos.length === 0) {
    content.appendChild(
      el("p", { class: "page__lead" }, "Foto's volg binnekort."),
    );
    page.appendChild(content);
    root.appendChild(page);
    return;
  }

  const grid = el("div", { class: "photo-grid" });
  for (const photo of portraitPhotos) {
    const item = el("figure", { class: "photo-grid__item", "data-cursor-label": "Bekyk" });
    item.appendChild(
      picture({
        entry: photo,
        alt: "",
        sizes: "(min-width: 769px) 50vw, 50vw",
      }),
    );
    item.addEventListener("pointerdown", () => buzz("tap"), { passive: true });
    grid.appendChild(item);
  }
  content.appendChild(grid);

  page.appendChild(content);
  root.appendChild(page);

  // Subtle stagger as the grid scrolls into view
  gsap.from(grid.querySelectorAll(".photo-grid__item"), {
    opacity: 0,
    y: 24,
    duration: 0.6,
    stagger: 0.04,
    ease: "power2.out",
    scrollTrigger: { trigger: grid, start: "top 85%" },
  });
  ScrollTrigger.refresh();
}
